import { Box, Button, Container, Flex, FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputLeftElement, Select, Stack, Text, useToast } from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import { MdMailOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { IAvailableCourse } from '../../../models/trainee-course.model';
import AdminHelpers from '../../../services/admin/admin.service';
import coursesService from '../../../services/courses.service';
import Adminroutes from '../routes';

const NewAlumni = () => {
    const navigate = useNavigate();
    const [gender, setGender] = useState<any[]>([]);
    const [courses, setCourses] = useState<IAvailableCourse[]>([]);
    const [courseId, setCourseId] = useState('');
    const toast = useToast();
    const courseFormatRef = useRef<HTMLSelectElement>(null);
  
    useEffect(() => {
      const maingender = [
        {
          id: "1",
          title: "Male",
        },
        {
          id: "2",
          title: "Female",
        },
      ];
      setGender(maingender);
      coursesService.getAvailableCourses().then(
        (res) => {
          const availablecourses: IAvailableCourse[] = res;
          const  realCourses = availablecourses.filter((each) => each.course !== null)
         
            setCourses(realCourses);
        }
    )
    }, []);
  
  
    const formik = useFormik({
      validate: (values: any) => {
        const errors: any = {};
        const regex: any = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
        if (!values.fullname) {
          errors.fullname = "Full Name is required";
        }
        if (!values.address) {
          errors.address = "Address is required";
        }
        if (!values.courseCode) {
          errors.courseCode = "Course Code is required";
        }

        if (!values.emailAddress) {
          errors.emailAddress = "Email Address is required";
        }
        if (!regex.test(values.emailAddress)) {
          errors.emailAddress = "Please enter a valid email address";
        }
        if (!values.phoneNumber) {
          errors.phoneNumber = "Phone Number is required";
        }
        if (values.phoneNumber.toString().length !== 11 ) {
          errors.phoneNumber = "Please enter valid phone number";
        }
        if (!values.admissionDate) {
          errors.admissionDate = "Admission Date is required";
        }
        if (!values.graduationDate) {
            errors.graduationDate = "Admission Date is required";
        }
        if (!values.gender) {
          errors.gender = "Gender is required";
        }
        return errors;
      },
      initialValues: {
        fullname: "",
        emailAddress: "",
        phoneNumber: "",
        gender: "",
        address: "",
        admissionDate: "",
        graduationDate: "",
        courseCode: "",

      },
      onSubmit: async (values) => {
        const RegInfo: any = {
          name: values.fullname,
          email: values.emailAddress,
          course_code: values.courseCode,
          phone: values.phoneNumber.toString(),
          address: values.address,
          gender: values.gender,
          admission_date: values.admissionDate,
          graduation_date: values.graduationDate,
        };
        try {
          const Reg = await AdminHelpers.createAlumni(RegInfo);
          if (Reg) {
            
            toast({
              title: "Alumni",
              description: `Alumni created successfully`,
              status: "success",
            });
            navigate(-1);
          }
        } catch (error: any) {
          toast({
            title: "Alumni",
            description: `${error.response.data.message}`,
            status: "error",
          });
        }
      },
    });
  
    return (
      <>
        <Box minHeight="100vh" pb="30px" bg="#F9F8F8">
          <Container
            width={{ lg: "40%", md: "80%", sm: "95%", base: "95%" }}
            maxWidth={"84%"}
            px={0}
            pt="100px"
            right={0}
            bg="F9F8F8"
            mx="auto"
          >
            <Box
              mb="60px"
              display="flex"
              alignItems="center"
              border="1px solid #616161"
              padding={"5px 12px"}
              width="fit-content"
              borderRadius="5px"
              cursor="pointer"
            >
              <HiArrowNarrowLeft color="#616161" fontSize="20px" />
              <Text
                fontSize="14px"
                color="#616161"
                pl="5px"
                onClick={() => navigate(Adminroutes.Alumni)}
                fontWeight={700}
              >
                Back to Alumni
              </Text>
            </Box>
            <Box
              bg="white"
              px="40px"
              py="60px"
              boxShadow="sm"
              rounded="lg"
              height="auto"
              mb="30px"
            >
              <Text fontWeight="700" fontSize="24px" color="#1E1E1E">
                New Alumni
              </Text>
              <Box mt={4}>
                <form onSubmit={formik.handleSubmit}>
                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                  >
                    <FormControl
                      isInvalid={
                        formik.errors.fullname && formik.touched.fullname
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Full Name{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        bg="inputText.500"
                        placeholder="Enter full name"
                        value={formik.values.fullname}
                        name="fullname"
                        onChange={formik.handleChange}
                        fontSize={12}
                      />
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.fullname}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>
  
                  <FormControl
                    mb="25px"
                    isInvalid={
                      formik.errors.emailAddress && formik.touched.emailAddress
                        ? true
                        : false
                    }
                  >
                    <FormLabel color="brand.subtitle" fontSize={12}>
                      Email address{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <InputGroup>
                      <InputLeftElement
                        color="brand.subtitle"
                        pointerEvents="none"
                        children={<MdMailOutline />}
                      />
                      <Input
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder="alex@gmail.com"
                        onChange={formik.handleChange}
                        fontSize={13}
                      />
                    </InputGroup>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.emailAddress}{" "}
                    </FormErrorMessage>
                  </FormControl>
  
                  <FormControl
                    mb="25px"
                    mt={6}
                    isInvalid={
                      formik.errors.phoneNumber && formik.touched.phoneNumber
                        ? true
                        : false
                    }
                  >
                    <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                      Phone Number{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="080*******"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
  
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.phoneNumber}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                      isInvalid={
                        formik.errors.address && formik.touched.address
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Address{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Enter address"
                          type="address"
                          bg="inputText.500"
                          name="address"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          fontSize={12}
                          height='6.2rem'
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.address}
                      </FormErrorMessage>
                    </FormControl>
  
                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                    mt={6}
                    spacing={10}
                  >
                    <FormControl
                      isInvalid={
                        formik.errors.courseCode && formik.touched.courseCode ? true : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Course Enrolled for{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select 
                      placeholder='please select an option' 
                      fontSize="12px"
                      name='courseCode'
                      value={formik.values.courseCode} 
                      bg="inputText.500"
                      onChange={formik.handleChange}>
                        {
                          courses.map((each: any, index: number) =>
                            <option key={index} value={each.id}>{each.course.name.slice(0, 28)}...</option>
                          )
                        }
                      </Select>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.courseCode}
                      </FormErrorMessage>
                    </FormControl>
  
                    <FormControl
                      isInvalid={
                        formik.errors.gender && formik.touched.gender
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Gender{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        ref={courseFormatRef}
                        variant="outline"
                        bg="inputText.500"
                        size="sm"
                        fontSize={12}
                        placeholder="Select Gender"
                        value={formik.values.gender}
                        name="gender"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        color="brand.subtitle"
                      >
                        {gender.map((each) => (
                          <option key={each.id} value={each.title}>
                            {" "}
                            {each.title}{" "}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.gender}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>
  
                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                    mt={6}
                    spacing={10}
                  >
  
                    <FormControl
                      isInvalid={
                        formik.errors.admissionDate &&
                        formik.touched.admissionDate
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Admission Date{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Select admission date"
                          type="date"
                          bg="inputText.500"
                          name="admissionDate"
                          value={formik.values.admissionDate}
                          onChange={formik.handleChange}
                          fontSize={12}
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.admissionDate}
                      </FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        formik.errors.graduationDate &&
                        formik.touched.graduationDate
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Graduation Date{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Select graduation date"
                          type="date"
                          bg="inputText.500"
                          name="graduationDate"
                          value={formik.values.graduationDate}
                          onChange={formik.handleChange}
                          fontSize={12}
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.graduationDate}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>
                  <Flex  mt={8} justifyContent={'flex-end'}>
                    <Button
                      cursor="pointer"
                      size='sm'
                      px={6}
                      bg="red"
                      color="white"
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      fontSize={14}
                      borderRadius={'4px'}
                      onClick={()=>formik.handleSubmit}
                    >
                      CREATE ALUMNI
                    </Button>
                  </Flex>
                </form>
              </Box>
            </Box>
          </Container>
        </Box>
      </>
    );
}

export default NewAlumni